import React from 'react';
import { Input } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';

export default function BeneficiosTab({ dados, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <Secao titulo="Vale Transporte">
        <Input label="Valor Diário R$" type="number" step="0.01" value={dados.vale_transporte || ''} onChange={e => onChange('vale_transporte', e.target.value)} style={{ maxWidth: 220 }} />
      </Secao>
      <Secao titulo="Vale Alimentação">
        <Input label="Valor Diário R$" type="number" step="0.01" value={dados.vale_alimentacao || ''} onChange={e => onChange('vale_alimentacao', e.target.value)} style={{ maxWidth: 220 }} />
      </Secao>
    </div>
  );
}
